// LoginContainer.tsx
import React from 'react';
import { signInWithGooglePopup } from "../firebaseConfig"
import GoogleIcon from '@mui/icons-material/Google';


interface LoginContainerProps {
    onLogin: () => void;
}

const LoginContainer: React.FC<LoginContainerProps> = ({ onLogin }) => {
    const handleGoogleLogin = async () => {
        const response = await signInWithGooglePopup();
    };

    return (
        <div className="login-container">
            <button className="login-button" onClick={handleGoogleLogin}>
                <GoogleIcon style={{'paddingRight': '5px'}}/>
                Acceder con Google</button>
        </div>
    );
};

export default LoginContainer;
